import { TreatmentPageTranslations } from "./types";

export const deTranslations: TreatmentPageTranslations = {
    pageTitle: "Maßnahme verordnen",
    treatment: "Maßnahme",
    priority: "Priorität",
    justification: "Indikation",
    orderTreatment: "Verordnen",
    clearForm: "Löschen",
    orderedTreatments: "Verordnete Maßnahmen",
    selectPlaceholder: "Auswählen…"
};
